import { convertMoneytoFloat } from '../functions/helpers';


export default (value) => {
  const decimals = convertMoneytoFloat(value);
  return decimals !== 0;
};



// WEBPACK FOOTER //
// ./src/common/validations/money-required.js